import { render, staticRenderFns } from "./GCash.vue?vue&type=template&id=12e855ed&scoped=true"
import script from "./GCash.vue?vue&type=script&lang=js"
export * from "./GCash.vue?vue&type=script&lang=js"
import style0 from "./GCash.vue?vue&type=style&index=0&id=12e855ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e855ed",
  null
  
)

export default component.exports